import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SelectColor from 'components/TagColorFormatter/components/SelectColor';
import ColorTag from './components/ColorTag';

const StyledTagWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const TagColorFormatter = ({ data, editable, onChangeRow, rowIndex }) => {
  const [show, setShow] = useState(null);

  const handleDeleteColor = color => e => {
    e.stopPropagation();
    if (editable) {
      const changed = data.color.filter(item => {
        return item.value !== color;
      });
      onChangeRow({ ...data, color: changed });
    }
  };

  const handleClose = () => {
    setShow(null);
  };

  const handleOpen = () => {
    if (editable) {
      setShow(show ? null : rowIndex);
    }
  };

  return (
    <SelectColor
      data={data}
      onChangeRow={onChangeRow}
      show={rowIndex === show}
      onOutsideClick={handleClose}
      direction={rowIndex > 3 ? 'bottom' : 'top'}>
      <StyledTagWrapper onClick={handleOpen}>
        {data.color.map(item => (
          <ColorTag
            key={item.value}
            color={item.color}
            labelColor={item.labelColor}
            label={item.label}
            onClick={editable && handleDeleteColor(item.value)}
          />
        ))}
      </StyledTagWrapper>
    </SelectColor>
  );
};

TagColorFormatter.propTypes = {
  data: PropTypes.object.isRequired,
  editable: PropTypes.bool.isRequired,
  onChangeRow: PropTypes.func.isRequired,
  rowIndex: PropTypes.number.isRequired,
};

export default TagColorFormatter;
